import { render, staticRenderFns } from "./RsaPazienteAccettazioneSettingLivelliListComponent.vue?vue&type=template&id=18410050"
import script from "./RsaPazienteAccettazioneSettingLivelliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAccettazioneSettingLivelliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports